"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Avatar = _interopRequireDefault(require("../Avatar"));

var AccountAvatar = function AccountAvatar(_ref) {
  var srcs = _ref.srcs,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["srcs"]);

  if (srcs.length === 1) {
    return /*#__PURE__*/_react["default"].createElement(_Avatar["default"], (0, _extends2["default"])({}, rest, {
      src: srcs[0]
    }));
  } // Take the first three and combine into a mosaic


  var _srcs$slice = srcs.slice(0, 3),
      _srcs$slice2 = (0, _slicedToArray2["default"])(_srcs$slice, 3),
      img1 = _srcs$slice2[0],
      img2 = _srcs$slice2[1],
      img3 = _srcs$slice2[2];

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col h-12 w-12"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-center h-1/2 relative z-10"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: img1,
    alt: img1,
    className: "w-auto h-full absolute rounded-full",
    style: {
      top: 5
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex h-1/2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative w-1/2 h-full"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: img2,
    alt: img2,
    className: "w-auto h-full absolute rounded-full",
    style: {
      bottom: 5,
      left: 5
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative w-1/2 h-full"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: img3,
    alt: img3,
    className: "w-auto h-full absolute rounded-full",
    style: {
      bottom: 5,
      right: 5
    }
  }))));
};

var _default = AccountAvatar;
exports["default"] = _default;
//# sourceMappingURL=AccountAvatar.js.map